import { MantineTheme } from "@mantine/core";
import { DataMapMarkerProps, latLng, ValuesRecord } from "@mcurros2/microm";

export function StandardViewMarkerRenderer(record: ValuesRecord, position: latLng, theme: MantineTheme): DataMapMarkerProps | null {
    const personal = record[5];
    const canales = record[2];
    const cadena = record[1];

    const markerProps: DataMapMarkerProps = {
        position: position,
        title: `${canales}${canales && cadena ? ' - ' : ''}${cadena} - ${personal ?? 'Sin personal asignado'}`,
        assignColorByValue: `${personal}` ?? 'default',
    }
    return markerProps;
}